export const IP_INFO_KEY = '86670d7a3cf39d';
